<template>
  <div>
    <!-- 流水对比 -->
    <el-dialog :title="$t('message.flowMatching')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1442px" center>
      <div class="detail">
        <!-- 订单类别 -->
        <div class="row">
          <!--支付方式  -->
          <div class="item">
            <span>{{ $t('message.methodPayment') }}:</span> {{ detail.bill_method_name }}
          </div>
          <!--汇款人  -->
          <div class="item">
            <span>{{ $t('message.remitter') }}:</span>{{ detail.pay_realname }}
          </div>
          <!--汇款金额  -->
          <div class="item">
            <span>{{ $t('message.remittanceAmoun') }}:</span>{{
              detail.pay_amount ? formatNumber(detail.pay_amount) : detail.pay_amount }}
          </div>
          <!--汇款截图  -->
          <div class="item">
            <span>{{ $t('message.remittanceScreenshots') }}:</span>
            <el-image style="width: 40px; height: 40px;vertical-align:middle;" :src="detail.pay_image"
              :preview-src-list="[detail.pay_image]" v-if="detail.pay_image">
            </el-image>
          </div>
          <!--转账备注  -->
          <div class="item">
            <span>{{ $t('message.transferNote') }}:</span>{{ detail.pay_remark }}
          </div>
          <!--客户名  -->
          <div class="item">
            <span>{{ $t('message.customerName') }}:</span>{{ detail.user ? detail.user.realname : '' }}
          </div>
          <!--客户ID  -->
          <div class="item">
            <span>{{ $t('message.clientID') }}:</span>{{ detail.user_id }}
          </div>

        </div>

        <div class="table">
          <ol>
            <li class="flex05">NO</li>
            <!-- 导入日期 -->
            <li>
              {{ $t("message.importDate") }}

            </li>
            <!-- 银行流水日期 -->
            <li>
              {{ $t("message.bankStatementDate") }}
            </li>
            <!-- 类型 -->
            <li>{{ $t("message.Kintype") }}</li>
            <!-- 流水编号 -->
            <li>{{ $t("message.flowNumber") }}</li>
            <!-- 流水名义 -->
            <li>
              {{ $t("message.journalDetail") }}
            </li>

            <!-- 入金金額（円） -->
            <li>{{ $t("message.withdrawalAmount") }}</li>
            <!-- 出金金額（円） -->
            <li>{{ $t("message.depositAmount") }}</li>
            <!-- 当时余额 -->
            <!-- <li>{{ $t("message.currentBalance") }}</li> -->
            <!-- 其他备注 -->
            <li class="flex15">{{ $t("message.otherRemarks") }}</li>
            <!-- 操作 -->
            <li>{{ $t("message.operation") }}</li>

          </ol>
          <div class="list" v-if="tableData != false">
            <ul v-for="(item, index) in tableData" :key="index">
              <li class="flex05">{{ index + 1 }}</li>
              <!-- 导入日期 -->
              <li>
                <span class="time">
                  {{ item.created_at }}
                </span>
              </li>
              <!-- 银行流水日期 -->
              <li> <span class="time"> {{ item.pay_at }} </span></li>
              <!-- 类型 -->
              <li> {{ getBillMethod(item.bank_method) }}</li>
              <!-- 流水编号 -->
              <li>
                {{ item.serial_number }}
              </li>
              <!-- 流水名义 -->
              <li>
                {{ item.account }}
              </li>
              <!-- 出金金額（円） -->
              <li>
                {{ item.amount_out ? formatNumber(item.amount_out) : item.amount_out }}
              </li>
              <!-- 入金金額（円） -->
              <li>
                {{ item.amount_in ? formatNumber(item.amount_in) : item.amount_in }}
              </li>
              <!-- 当时余额 -->
              <!-- <li>
                {{ item.balance }}
              </li> -->
              <!-- 其他备注 -->
              <li class="flex15">{{ item.remark }}</li>
              <!-- 流水绑定 -->
              <li>
                <!-- 确定 -->
                <el-button type="primary" @click="updateBillAndMatch(item)">
                  {{ $t("message.ok") }}
                </el-button>
              </li>
            </ul>
          </div>
          <!-- 暂无流水匹配 -->
          <div class="text" v-else>
            <!-- 暂无流水匹配 -->
            {{ $t("message.thereIsNoFlowMatchin") }}

          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    detail: { type: Object },
    BillMethod: { type: Array }
  },

  data() {
    return {
      user_id: '',
      type: "",
      tableData: [
        {}
      ],

      dialogVisible: false,

    };
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.tableData = []
        this.matchPossibleBankBill()
      }
    },
  },
  methods: {
    // 银行类型
    getBillMethod(type) {
      let data = this.BillMethod.find(item => item.key == type)
      return data ? data.value : ''
    },
    // 列表
    matchPossibleBankBill() {
      this.$api.financialApi.matchPossibleBankBill({ bill_id: this.detail.id }).then(res => {
        this.tableData = res.data
      })

    },
    //流水搬定
    updateBillAndMatch(item) {

      let datas = {
        bill_id: this.detail.id,
        bank_bill_id: item.id,
      }
      // 
      this.$confirm(
        this.$t(
          "message.confirmThatYouWantToStreamBind"
        ),
        // 确认提醒
        this.$t("message.confirmToRemind"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.$api.financialApi.updateBillAndMatch(datas).then(res => {
            this.$message.success(res.msg)
            this.dialogVisible = false
          })
        })
        .catch(() => { });

    }

  },

};
</script>
<style lang='scss' scoped>
.detail {



  .row {
    display: flex;
    padding: 10px 20px;
    line-height: 40px;
    background: #EDEFF4;
    border-radius: 4px;
    margin-bottom: 24px;

    .item {
      margin-right: 40px;

      span {
        margin-right: 5px;
      }

    }
  }




  .table {
    ol {
      display: flex;
      height: 40px;
      background: #edeff4;
      border-radius: 4px 4px 0px 0px;
      justify-content: center;
      align-items: center;

      li {
        height: 40px;
        text-align: center;
      }
    }

    .list {
      max-height: 500px;
      overflow-y: auto;
    }

    .text {
      text-align: center;
      font-size: 30px;
      margin: 20px;
    }

    ul {
      display: flex;
      padding: 10px 0;
      border-bottom: 1px solid #edeff4;

      /deep/.el-upload-dragger {
        width: 60px;
        height: 60px
      }
    }

    li {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 5px;

      &:nth-last-child(1) {
        margin-right: 0;
      }

      span {
        width: 80px;
        text-align: center;
      }
    }

    .flex2 {
      flex: 3;
    }

    .flex05 {
      flex: 0.5;
    }

    .flex15 {
      flex: 1.8;
    }

    .template {
      width: 100%;
      padding: 10px;
      background-color: #fff;
      height: 80px;
      overflow: hidden;
      cursor: pointer;
    }
  }
}
</style>